import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { trace } from 'owa-trace';
import { DEFAULT_LIST_VIEW_WIDTH, MAX_LIST_VIEW_WIDTH, MIN_LIST_VIEW_WIDTH, DEFAULT_LIST_VIEW_HEIGHT, MAX_LIST_VIEW_HEIGHT, MIN_LIST_VIEW_HEIGHT, } from '../actions/setListViewDimension';
/**
 * Gets the dimensions for the list view
 * @returns the listView dimensions
 */
export default function getListViewDimensions() {
    var userConfiguration = getUserConfiguration();
    var listViewWidth = DEFAULT_LIST_VIEW_WIDTH;
    var listViewHeight = DEFAULT_LIST_VIEW_HEIGHT;
    // globalFolderViewState is undefined for user using Owa first time
    // use default dimensions instead
    if (!userConfiguration.ViewStateConfiguration.GlobalFolderViewState) {
        return { listViewWidth: listViewWidth, listViewHeight: listViewHeight };
    }
    var globalFolderViewState;
    try {
        // try to get the list view dimensions from the user config
        globalFolderViewState = JSON.parse(userConfiguration.ViewStateConfiguration.GlobalFolderViewState);
    }
    catch (error) {
        trace.warn('GetListViewDimensions: Deserialize globalFolderViewState failed: ' + error.Message);
    }
    if (globalFolderViewState) {
        // check if the dimensions are defined and are within bounds.
        // dimensions may not be defined if user has never changed LV dimensions
        var storedWidth = globalFolderViewState.Width;
        var storedHeight = globalFolderViewState.Height;
        listViewWidth =
            storedWidth && storedWidth >= MIN_LIST_VIEW_WIDTH && storedWidth <= MAX_LIST_VIEW_WIDTH
                ? storedWidth
                : listViewWidth;
        listViewHeight =
            storedHeight &&
                storedHeight >= MIN_LIST_VIEW_HEIGHT &&
                storedHeight <= MAX_LIST_VIEW_HEIGHT
                ? storedHeight
                : listViewHeight;
    }
    return { listViewWidth: listViewWidth, listViewHeight: listViewHeight };
}
//# sourceMappingURL=getListViewDimensions.js.map